import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import styles from "./DetailsSection.module.css";
import { ReactComponent as CalendarIcon } from "../../assets/icons/Calendar2.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/addres.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/Call.svg";
import { DateTime } from "ts-luxon";

interface BusinessLinks {
  address?: string;
  phone?: string;
  whatsapp?: string;
  location?: string;
}

const DetailsSection: React.FC = () => {
  const location = useLocation();
  const { fromTime, toTime, selectedPersianDate, categoryId } =
    location.state || {};

  const [links, setLinks] = useState<BusinessLinks>({});

  useEffect(() => {
    const storedProfile = localStorage.getItem("business-profile");
    if (storedProfile) {
      try {
        const parsed = JSON.parse(storedProfile);
        const data = parsed.data || {};

        const rawWhatsapp = data.whatsapp || parsed.whatsapp || "";
        const extractedPhone =
          rawWhatsapp.startsWith("https://wa.me/") && rawWhatsapp.length > 12
            ? rawWhatsapp.replace("https://wa.me/", "")
            : "شماره‌ای ثبت نشده";

        setLinks({
          address: data.address || parsed.address,
          phone: extractedPhone,
          whatsapp: rawWhatsapp,
          location: data.location,
        });
      } catch (error) {
        console.error("❌ خطا در خواندن business-profile:", error);
      }
    }
  }, []);

  const daysOfWeek = [
    "دوشنبه",
    "سه‌شنبه",
    "چهارشنبه",
    "پنج‌شنبه",
    "جمعه",
    "شنبه",
    "یک‌شنبه",
  ];
  const months = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const fromDate = fromTime ? DateTime.fromISO(fromTime) : null;
  const toDate = toTime ? DateTime.fromISO(toTime) : null;

  let formattedDate = "نامشخص";
  if (selectedPersianDate && fromDate) {
    const parts = selectedPersianDate.split("/");
    const day = parts[2];
    const monthIndex = parseInt(parts[1]) - 1;
    const dayName = daysOfWeek[fromDate.weekday - 1];
    formattedDate = `روز ${day} ${months[monthIndex]}`;
  }

  const formattedFrom = fromDate
    ? `${formattedDate} - ساعت ${fromDate.toFormat("HH:mm")}`
    : "نامشخص";

  const formattedTo = toDate ? toDate.toFormat("HH:mm") : "";

  return (
    <div className={styles.detailsContainer}>
      {/* تاریخ و ساعت */}
      <div className={styles.row}>
        <CalendarIcon className={styles.icon} />
        <div>
          <p className={styles.label}>:تاریخ و ساعت وقت</p>
          <p className={styles.value}>
            {formattedFrom} {formattedTo && `الی ${formattedTo}`}
          </p>
        </div>
      </div>

      {/* آدرس */}
      {links.address && (
        <div className={styles.row}>
          <LocationIcon className={styles.icon} />
          <div>
            <p className={styles.label}>:آدرس</p>
            <p className={styles.value}>{links.address}</p>
          </div>
        </div>
      )}

      <div className={styles.row}>
        <PhoneIcon className={styles.icon} />
        <div>
          <p className={styles.label}>:تلفن</p>
          <p className={styles.value}>{links.phone}</p>
        </div>
      </div>

      <div className={styles.divider}></div>

    </div>
  );
};

export default DetailsSection;
